import _ from 'lodash';
import { prettifyDateTimeV2 } from '@nexio/emvio-util-app';
import { getStore } from '../store';

export function arrayOfStringsToStringWithSeparator(arrayOfStrings, separator = ' ') {
    let addedExtraSeparator = true;

    return arrayOfStrings.reduce((accumulator, value = '') => {
        if (!value) {
            return accumulator;
        }

        if (accumulator.substring(0, accumulator.length - separator.length)) {
            addedExtraSeparator = !value;

            return `${accumulator}${addedExtraSeparator ? '' : separator}${value}`;
        }

        return `${accumulator}${value}`;
    }, '');
}

export function capitalizeFirstLetterOfEachWord(str) {
    const input = str ? `${str}` : '';
    const strToArray = input.trim().split(' ');
    const uppercased = strToArray.map((item) => {
        const firstLetter = item[0] ? item[0] : '';

        return firstLetter.toUpperCase() + item.slice(1);
    });

    return uppercased.join(' ');
}

export function prettifyCardNumber(strOrNum) {
    const input = strOrNum ? `${strOrNum}` : '';

    return input ? `${input.replace(/([X*]+)/gi, '...')}` : '';
}

export function upperCaseAll(strOrNum) {
    return `${strOrNum}`.toUpperCase();
}

export function getGoodAmountNumber(amount, decimalPlaces) {
    const amountNumber = Number(amount);
    if (!isNaN(amountNumber)) {
        return amountNumber.toFixed(decimalPlaces);
    } else {
        return amountNumber;
    }
}

export function prettifyDate(date, options = {}) {
    let optionsSane = _.cloneDeep(options);
    _.set(optionsSane, 'timezoneOutput', _.get(options, 'timezoneOutput') || _.get(getStore().getState(), 'entities.userSettings.timezone'));

    return prettifyDateTimeV2(date, optionsSane);
}

export function prettifyDateNoTimeZone(date) {

    return prettifyDateTimeV2(date, {
        timezoneOutput: 'UTC',
        returnDateOnly: true
    });
}

export function prettifyDatetimeNoTimeZone(date) {

    return prettifyDateTimeV2(date, { timezoneOutput: 'UTC', returnDateOnly: false });
}

export function prettifyRate(rate) {
    if (_.isInteger(rate)) {
        return `$${rate}.00`;
    }

    const oneDecimalPointRegex = /.*\.\d$/;

    if (oneDecimalPointRegex.test(rate)) {
        return `$${rate}0`;
    }

    return `$${rate}`;
}

export const toTitleCase = (s) => {
    const str = (s ?? '').toString().trim();

    return str === '' ? '' : capitalizeFirstLetterOfEachWord(str.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/^\w/, (c) => c.toUpperCase()));
};
